import React from 'react'
import { ClipLoader } from 'react-spinners'

import './index.scss'

const Spinner = ({ type = 'green', size = 35, containerHeight = "auto" ,...props}) => {
  return (
    <div className="spinner__container" style={{ height: containerHeight }} {...props}>
      <ClipLoader color="#009688" size={size} />
    </div>
  )
}

export default Spinner